// extracted by mini-css-extract-plugin
module.exports = {"footer":"M5Footer_footer__hqD4Y","footerArrow":"M5Footer_footerArrow__NQYtw","footerButton":"M5Footer_footerButton___Wg8n"};